import Div from '@jumbo/shared/Div';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Download, RemoveRedEye, Widgets } from '@mui/icons-material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { LoadingButton } from '@mui/lab';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import {
  Button, Checkbox, Dialog, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography,Tooltip,
  DialogActions,Fab,
  Chip,
  Autocomplete,
  Box,
  Badge,
  Avatar,
  Card,
  IconButton,
  Pagination,
  TextareaAutosize,
} from '@mui/material';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import NoDataPlaceholder from 'app/shared/NoDataPlaceholder';
import TableView from 'app/shared/Tableview/Tableview';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import { Formik, Form, Field } from 'formik';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
// import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import styled from '@emotion/styled';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { BACKEND_APP_URL } from 'app/utils/constants/paths';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import JumboBookmark from '@jumbo/components/JumboBookmark';
import Span from '@jumbo/shared/Span';
import { DataGrid } from '@mui/x-data-grid';
import { ExcelTransactionExp } from 'app/shared/ExcelGenerate/ExcelGenerateForSearch';
import { number } from 'prop-types';
import JumboConfirmDialog from '@jumbo/components/JumboConfirmDialog';
import { ItemBlock } from 'app/utils/appHelpers';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
// import EditSaleTXN from './EditOutwardTxn';
export function formatDate(inputDate) {
  const dateObject = new Date(inputDate);
  const day = String(dateObject.getDate()).padStart(2, '0');
  const month = String(dateObject.getMonth() + 1).padStart(2, '0');
  const year = dateObject.getFullYear();
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}
export function daysSince(inputDate) {
  // Parse the input date string into a Date object (assuming MM/DD/YYYY format)
  const inputDateTime = new Date(inputDate);
  // Calculate the time difference in milliseconds
  const timeDifference = new Date() - inputDateTime;
  // Convert milliseconds to days
  const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
  return daysDifference;
}

function Acc() {

  const [EditSaleDialoge, setEditSaleDialoge] = useState(false)
  const [Data, setData] = useState([])
  const [totalData, settotalData] = useState({})
  const [DefaultDialoge, setDefaultDialoge] = useState(true)
  const [MData, setMData] = useState([])
  // const [FormData, setFormData] = useState({})
  const [Memonumber, setMemonumber] = useState([])
  const [value, setValue] = React.useState(0);
  const [currentType, setCurrentType] = useState(null);
  const [selectedtrParty, setSelectedTrParty] = useState(null)
  const [selectedMemoNo, setSelectedMemoNo] = useState(null)
  const [SelectedStone, setSelectedStone] = useState([])
  const [SelectedTrID, setSelectedTrID] = useState([])
  const [SelectedStoneDetail, setSelectedStoneDetail] = useState([])
  // const [generateTextInvoiceDIaloge, setGenerateTextInvoiceDIaloge] = useState(true)
  const [pdfData, setPdfData] = useState(null);
  const jumboco = useJumboAuth();
  // console.log( );
  const [formval,setFormval] = useState({
    startDate: '',
    transactionType: [],
    AC_TYPE: [],
    endDate: '',
  })
  const [open, setOpen] = useState(false)
  // const handleClose = () => setOpen(!open)
  // const swal = useSwalWrapper()
  // useEffect(() => {
  //   let seData = MData?.filter((st) => SelectedStone?.includes(st.FL_STONE_ID))
  //   setSelectedStoneDetail(seData)
  //   // console.log(SelectedStone);
  // }, [SelectedStone])
  // const location = useLocation()
  // console.log(location);
  // const fetchtrdata = () => {
  //   setPdfData(null)
  //   setMData([])
  //   setSelectedStone([])
  //   jwtAuthAxios.get('transation/stoneByParty?partyId=' + selectedtrParty + '&trtype=' + value + '&MemoNO=' + selectedMemoNo).then((res) => {
  //     let sData = res.data?.data?.sort((a, b) => (a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1))
  //     setMData(sData);

  //   }).catch(() => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'something Went Wrong',
  //     })
  //   })
  // }
  // const fetchMemoNumber = () => {
  //   setMemonumber([])
  //   setSelectedStone([])
  //   jwtAuthAxios.get('transation/GetMemoNumber?partyId=' + selectedtrParty + '&trtype=' + value).then((res) => {
  //     // let ManageStoneDisc = res.data?.data?.sort((a, b) => (a.FL_STONE_ID > b.FL_STONE_ID ? 1 : -1));
  //     setMemonumber(res.data?.data);
  //   }).catch(() => {
  //     swal.fire({
  //       icon: 'error',
  //       text: 'something Went Wrong',
  //     })
  //   })
  // }





  const {rights} = useJumboAuth();
  const submitForm =async (values,page=1)=>{
    setFormval(values)
    setData([]);
    await jwtAuthAxios.post('acc',values).then(res=> {
      setData(res.data.Data);
      // return
      // settotalData(res.data);
      setDefaultDialoge(false)}).catch(alert)
  }
  const handleRemoveAccTr= async(data)=>{
    console.log(data);
    if(window.confirm('are you sure')){

      await jwtAuthAxios.post('acc/removebankhistory',data).then(res=>{
        submitForm()
      }).catch(alert)
    }
  }
  const columns = [
    { accessorKey: 'FL_TRANS_DATE', header: 'Date',Cell:(params)=>`${formatDate(params.row.original.FL_TRANS_DATE)}`},
    { accessorKey: 'DEBIT_AC', header: 'Debit A/c'},
    { accessorKey: 'CREDIT_AC', header: 'Credit A/c'},
    { accessorKey: 'TRANSTYPE_MEANING', header: 'Type'},
    // { accessorKey: 'FL_PR', header: 'PR Type'},
    { accessorKey: 'FL_CONV_RATE', header: 'Rate'},
    { accessorKey: 'CURRENCY', header: 'Payable currency'},
    { accessorKey: 'FL_PAID_AMT1',  header: 'AMT($)', Cell:(params)=> { return params.row.original?.FL_PAID_AMT1?.toFixed(2) || 0}},
    { accessorKey: 'FL_PAID_AMT2', header: 'AMT(RMB)', Cell:(params)=> { return params.row.original?.FL_PAID_AMT2?.toFixed(2) || 0}},
    { accessorKey: 'ACTION', header: 'Action', Cell:(params)=> 
    <>{rights?.edit == 1 && <Link type='button' size='small' to={`${params.row.original?.FL_TRANSTYPE=='P'?`/acc/partypayment/${params.row.original.FL_PR_TYPE}/${params.row.original.FL_TRANSNO}`:params.row.original?.FL_TRANSTYPE=='R'?`/acc/paymentreceive/${params.row.original.FL_PR_TYPE}/${params.row.original.FL_TRANSNO}`:`/acc/expensebill/E/E/${params.row.original.FL_TRANSNO}`}`}> <Button variant='contained' >Edit</Button></Link>} {rights?.delete==1 && <Button variant='contained' size='small' sx={{ml:2}} onClick={()=>handleRemoveAccTr(params.row.original)} color='error'>Delete</Button>}</>},]

  // const handleDetailView = async (e) => {
  //   // console.log(e);
  //   setData(null)
  //   await jwtAuthAxios.post('transation/transactionDetails', { P_NO: e.NO, P_TYPE: e.TYPE }).then(res => {
  //     // console.log(res.data.data);
  //     setData(res.data.data)
  //     setCurrentType('DETAILAll')
  //   }).catch(() => {
  //     alert('internal server error')
  //   })
  // }

  

  // const exporttoexcelData =async (id)=>{
  //   if(SelectedTrID.length > 0){
  //     return await Excelexport(SelectedTrID,id)
  //   }else{
  //     let confirm= await window.confirm(`Are You Sure Download all(${Data.length}) Transaction Data`)
  //     if(confirm){
  //     return await Excelexport(Data.map(d =>d.FL_BILL_NO),id)
  //    } else{
  //     return false
  //    }
  //   }
  // }
  // const [editabletrdetail,setEditabletrdetail] = useState(null)
  // useEffect(()=>{
    
  // },[])
  // const Excelexport =async (Data,id)=>{
  //   let {data}= await jwtAuthAxios.post('trreportexcel/getmemoSalelist?type='+id,{
  //     "BILL_NO":Data})
  //     return data
  // }
  const columnVirtualizerInstanceRef = useRef(null);
  const table = useMaterialReactTable({
    columnVirtualizerInstanceRef, //optional
    columnVirtualizerOptions: { overscan: 4 }, //optionally customize the virtualizer
    columns: columns, //500 columns
    data: Data || [],
    // enableRowActions: true,
    // enableEditing: true,
    selectAllMode: true,
    // onEditingRowChange: (rowIndexes) => console.log(rowIndexes),
    // enableColumnPinning: true,
    enableColumnResizing: true,
  });



// console.log();


  return (
    <div><Grid container>
      <Grid item xs={5} sx={{ mb: 2 }}>
          <Typography variant='h2'>ACC Transaction History</Typography>
        </Grid>
      <Grid item xs={7} sx={{ mb: 2 ,textAlign:'end'}}>
        <Stack direction={'row'} sx={{justifyContent: 'end'}} spacing={2}>
      {/* <Button sx={{minWidth: 92}}  variant={"contained"} size={"small"} onClick={exporttoexcelData} startIcon={<Download/>}>Export to excel</Button> */}
      <Button sx={{minWidth: 92}}  variant={"contained"} size={"small"} onClick={()=>{setDefaultDialoge(true)}} startIcon={<FilterAltOutlinedIcon/>}> Filter</Button>
        </Stack>
        </Grid>
        </Grid>

      <SelectTransactionModal formval={formval} handleSubmit={submitForm}  setData={setData} open={DefaultDialoge} handleClose={setDefaultDialoge} />
      <Paper>
      <MaterialReactTable  table={table} />
      </Paper>
    </div>
  );
}



const SelectTransactionModal = ({formval, open, handleClose,setData ,handleSubmit}) => {

  return (
    <Dialog open={open} maxWidth={'sm'} onClose={handleClose} >
      <DialogTitle>Search ACC Transaction</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={formval}
          onSubmit={async(values) => {
            
           await handleSubmit(values)
            // Handle form submission
            // console.log(values);
          
            
          }}
        >
          {({ values, handleChange,setValues }) => (
            <Form>
              <FormControl fullWidth margin="normal" >
                <InputLabel id="select-Type">TYPE</InputLabel>
                <Field
                  name="AC_TYPE"
                  as={Select}
                  labelId="select-Type"
                  fullWidth
                  multiple
                  value={values.AC_TYPE}
                  onChange={handleChange}
                  label="TYPE"
                >
                  {/* <MenuItem selected value=''>All</MenuItem> */}
                  <MenuItem  value='P'>Party</MenuItem>
                  <MenuItem  value='N'>Normal</MenuItem>
                  <MenuItem  value='A'>Advanced</MenuItem>
                  <MenuItem  value='E'>Expense</MenuItem>
            
                </Field></FormControl>
              <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    label="Start Date"
                    name="startDate"
                    value={values.startDate}
                    InputLabelProps={{ shrink: true }}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    margin="normal"
                    type="date"
                    label="End Date"
                    InputLabelProps={{ shrink: true }}
                    name="endDate"
                    value={values.endDate}
                    onChange={handleChange}
                  />
                </Grid>
                

             
                <Grid item  xs={12}>
              <FormControl fullWidth margin="normal" sx={{mt:0}}>
             
                  <InputLabel id="tr-Type">Transaction Type</InputLabel>
                <Field
                  name="transactionType"
                  as={Select}
                  labelId="tr-Type"
                  fullWidth
                  multiple
                  value={values.transactionType}
                  onChange={handleChange}
                  label="Transaction Type"
                >
                  {/* <MenuItem selected value=''>All</MenuItem> */}
                  <MenuItem  value='P'>Payment</MenuItem>
                  <MenuItem  value='R'>Receipt</MenuItem>
                  <MenuItem  value='E'>Expense</MenuItem>
            
                </Field>
              </FormControl>
              </Grid>
              </Grid>

              <DialogActions>
                {/* <Button onClick={handleClose}>Cancel</Button> */}
                <Button type="submit" color='primary' variant='contained'>Search</Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};


Acc.Modulename = 'ACCTXN'
export default Acc